<template>
  <div>
    <v-row class="mt-3" no-gutters align="center" justify="center">
      <v-col cols="6">
        <v-card flat>
          <v-card-text class="d-flex justify-center pa-0">
            <v-text-field placeholder="Enter a form name to search for Form" class="text-h5" hide-details outlined
              height="55px" rounded v-model="searchKeyword" @click="updateExpand()" :append-icon="searchBarIcon"
              clear-icon="mdi-close-circle" @click:append="clearSearch()">
            </v-text-field>
            <template v-if="!getKioskProfile.data().physicalKeyboard">
              <v-icon size="35" class="ml-2" v-if="!expand" @click="expand = !expand">mdi-keyboard-outline</v-icon>
              <v-icon size="35" class="ml-2" v-else @click="expand = !expand">mdi-keyboard-off-outline</v-icon>
            </template>

          </v-card-text>
          <v-expand-transition>
            <v-card-text class="d-flex justify-center ma-0 pa-0" v-if="expand">
              <SimpleKeyboard class="keyboard" @onKeyPress="onKeyPress" @onChange="onChange">
              </SimpleKeyboard>
            </v-card-text>
          </v-expand-transition>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-row no-gutters class="ma-2">
          <v-col cols="12" align="center" v-if="expand || searchKeyword !== ''">
            <v-card v-if="expand || searchKeyword !== ''" :ripple="false" class="containerBorder" width="95%" flat
              :height="cardHeight">
              <v-card-text v-if="matchingForms.length === 0" class="pa-0">
                <span class="text-h4"> No matching forms found. </span>
              </v-card-text>
              <div v-else>
                <v-card flat :height="cardHeight - 10" class="overflow-y-auto">
                  <v-row no-gutters class="mt-5 ml-6">
                    <v-col cols="4" v-for="(form, i) in matchingForms" :key="i">
                      <v-card class="mt-2 mb-2 mx-1 PDFborder" flat @click="displayDoc(form)" width="90%" height="100">
                        <v-row no-gutters class="fill-height" align="center">
                          <v-col cols="2" align="center">
                            <v-img src="@/assets/pdf.png" contain height="70"></v-img>
                          </v-col>
                          <v-col cols="10">
                            <v-card-title class="text-subtitle-1 font-weight-bold justify-center text-wrap">
                              {{ form.formName | trimLength }}
                            </v-card-title>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card>
              </div>
            </v-card>
          </v-col>

          <v-col cols="12" v-else>
            <v-row>
              <v-col cols="3" class="mt-5" align="center">
                <v-card width="95%" class="containerBorder" :height="cardHeight">
                  <v-card-title class="justify-center primary--text">{{ $t('categoryTitle') }}</v-card-title>
                  <v-divider class="mx-3"></v-divider>
                  <v-list class="overflow-y-auto" :height="cardHeight - 80">
                    <v-list-item v-for="(category, i) in $t('formCategory')" :key="i">
                      <v-list-item-content>
                        <v-btn height="45"
                          @click="$store.commit('setSelectedFormCat', { category: category.categoryType })"
                          v-bind:color="getSelectedFormCat.category.toLowerCase() === category.categoryType ? 'secondary' : 'primary'">{{
                            category.categoryName
                          }}</v-btn>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-col>

              <v-col cols="9" class="mt-5" align="center">
                <v-card width="95%" class="containerBorder" :height="cardHeight">
                  <v-card flat :height="cardHeight - 80" class="overflow-y-auto">
                    <v-row no-gutters class="mt-2 ml-6">
                      <v-col cols="4" v-for="(form, i) in getForms()" :key="i">
                        <v-card class="mt-2 mb-2 mx-1 PDFborder" flat @click="displayDoc(form)" width="90%"
                          height="100">
                          <v-row no-gutters class="fill-height" align="center">
                            <v-col cols="2" align="center">
                              <v-img src="@/assets/pdf.png" contain height="70"></v-img>
                            </v-col>
                            <v-col cols="10">
                              <v-card-text class="text-subtitle-1 font-weight-bold">
                                {{ form.formName | trimLength }}
                              </v-card-text>
                            </v-col>
                          </v-row>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SimpleKeyboard from "@/components/SimpleKeyboard";
export default {
  name: "forms",
  data() {
    return {
      expand: false,
      searchKeyword: "",
      searchBarIcon: "mdi-magnify",
      cardHeight: 685,
      tab: 0
    };
  },
  components: {
    SimpleKeyboard,
  },
  computed: {
    ...mapGetters(["getQnaKeyword", "getSelectedFormCat", "getFormCategories", "getKioskProfile"]),
    getCategoryType() {
      let temp = []
      this.$t('formCategory').forEach(type => {
        console.log('Form Category: ', type)
        if (type.categoryId === this.getSelectedFormCat.category) {
          temp = type.categoryType
        }
      })
      return temp;
    },
    matchingForms() {
      //return [];
      return this.$i18n
        .t("forms")
        .filter((form) =>
          form.formName.toLowerCase().includes(this.searchKeyword.toLowerCase())
        );
    },
    appendIcon() {
      return this.searchKeyword ? 'mdi-close-circle' : 'mdi-magnify';
    },
  },
  watch: {
    expand(newVal) {
      this.$store.commit("setIsThinking", false)
      this.$store.commit('setRequestQna', false)
      this.$store.commit("setSpeechRecognitionHandler", false);
      if (this.expand === false) {
        this.searchKeyword = ''
      }
      if (newVal) {
        this.searchBarIcon = "mdi-close-circle";
        if (this.$store.getters.getKioskProfile.data().physicalKeyboard) {
          this.cardHeight = 685;
        }
        else {
          this.cardHeight = 450;
        }
      } else {
        if (this.searchKeyword !== "") {
          this.searchBarIcon = "mdi-close-circle";
        } else {
          this.searchBarIcon = "mdi-magnify";
        }
        this.cardHeight = 685;
      }
    },
    getQnaKeyword(newVal) {
      this.searchKeyword = newVal
    },
    searchKeyword(newVal) {
      // if (newVal === "") {
      //   this.searchBarIcon = "mdi-magnify";
      // }


      if (newVal === "") {
        this.searchBarIcon = "mdi-magnify";
        // this.colLenght = 12;
      } else {
        this.searchBarIcon = "mdi-close-circle";
        // this.colLenght = 12;
      }
    }
  },
  methods: {
    updateExpand() {
      if (this.getKioskProfile.data().physicalKeyboard) {
        this.expand = false
      } else {
        if (this.expand) {
          this.expand = false
        } else {
          this.expand = true
        }
      }
    },
    clearSearch() {
      this.searchKeyword = "";
      this.$store.commit("setClearInput", true)
    },
    displayDoc(form) {
      console.log('At Display doc: ', form)
      this.$store.dispatch('addInteractionToPostgres', {
        actionType: 'Interaction',
        actionPayload:
          { module: 'Forms', navigateFrom: 'Forms', navigateTo: 'Forms', interactionType: 'Touch', elementContent: form.formName }
      })
      this.$store.dispatch('openPdfViewer', {
        url: form.document,
        name: form.formName,
        emailLink: form.documentUrl,
        type: 'pdf'
      })
    },
    getForms() {
      let temp = []
      let faqCats = this.getFormCategories.filter(category => category.locale === "en")
      console.log('Selected Form Category: ', this.getSelectedFormCat)
      let selectedFaqCat = faqCats.filter(cat => this.getSelectedFormCat.category.toLowerCase() === cat.categoryType)[0].categoryName
      this.$t('forms').forEach(form => {
        if (form.formCategory === selectedFaqCat.toLowerCase()) {
          temp.push(form)
        }
      })

      // if (category.type === 'E-Forms') {
      //   //console.log()
      //   return temp.filter(form => form.documentType === 'eforms');
      // } else {
      //   return temp.filter(form => form.documentType === category.type.toLowerCase());
      // }
      return temp
    },
    onChange(input) {
      this.searchKeyword = input;
    },
    onKeyPress(button) {
      this.$store.commit("setClearInput", false)
      if (button === "{bksp}")
        this.searchKeyword = this.searchKeyword.slice(0, -1);
    },
  },
  filters: {
    trimLength(val) {
      if (val.length < 65) {
        return val;
      }
      return `${val.substring(0, 60)}...`;
    },
  },
  mounted() {
    this.searchKeyword = this.getQnaKeyword
    console.log('Selected Form Category: ', this.getSelectedFormCat)
    // if (this.searchKeyword !== '') {
    //   this.colLenght = 12
    // }
  }
};
</script>

<style>
.formfolder {
  border-radius: 15px !important;
}

.containerBorder1 {
  border-width: 2px;
  border-style: solid;
  border-color: #2c6b87 !important;
  border-radius: 8px !important;
}

.text-wrap {
  overflow-wrap: anywhere;
}
</style>

<i18n>
{
  "en": {
      "cardHeader1": "Email links to Online Services",
      "cardHeader2": "Forms: Marriage Application, Notary and CPL",
      "link1": "Email link",
      "alter": "OR",
      "categoryTitle": "CATEGORIES"
    },
  "es":{
      "cardHeader1": "Servicios en Línea",
      "cardHeader2": "Formas: Marriage Application, Notary and CPL",
      "link1": "Email link",
      "alter": "O",
      "categoryTitle": "Categorías"
    }
}
</i18n>
